// extracted by mini-css-extract-plugin
export default {"pageWrap":"_a-z","fullWidth":"ab-z","heading":"bb-z","fullBleed":"cb-z","hidden":"db-z"};